/**
 * @graph-stack web-design-system
 * @graph-domain UX
 * @graph-business ラベルコンポーネント。フォームフィールドの見出しにデザイントークンを適用したプリミティブ
 * @graph-connects none
 */
import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '../../../lib/cn';

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

/** @graph-connects none */
export const Label = forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn('block text-sm font-medium text-[var(--color-text-secondary)]', className)}
    {...props}
  />
));

Label.displayName = 'Label';
